var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { bus: _vm.busModal, "max-width": "900px" },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("v-spacer"),
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Fechar ")]
              ),
              _vm.servico.permite_indicacao
                ? _c(
                    "BaseButton",
                    {
                      attrs: { primary: "" },
                      on: { click: _vm.openIndicacao }
                    },
                    [_vm._v(" Indicar serviço ")]
                  )
                : _vm._e(),
              _c(
                "BaseButton",
                { attrs: { primary: "" }, on: { click: _vm.sendComunicate } },
                [_vm._v(" Enviar comunicado ")]
              ),
              _c("v-spacer")
            ]
          }
        }
      ])
    },
    [
      _c("Title", { attrs: { title: _vm.servico.nome_servico || "Serviço" } }),
      _vm.loading
        ? _c("v-row", { attrs: { justify: "center", align: "center" } }, [
            _c(
              "div",
              { staticClass: "text-center ma-12 w-100" },
              [
                _c("v-progress-circular", {
                  attrs: { size: 50, color: "primary", indeterminate: "" }
                })
              ],
              1
            )
          ])
        : _c(
            "div",
            [
              _c(
                "v-row",
                [
                  _c("v-col", [
                    _c("div", [
                      _c("p", { staticStyle: { "margin-bottom": "0px" } }, [
                        _vm._v(" Descrição: ")
                      ]),
                      _c("small", { staticClass: "text-secondary" }, [
                        _vm._v(_vm._s(_vm.servico.descricao_servico))
                      ])
                    ])
                  ])
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c("v-col", [
                    _c("div", [
                      _c("p", { staticStyle: { "margin-bottom": "0px" } }, [
                        _vm._v(" Taxa: ")
                      ]),
                      _c("small", { staticClass: "text-secondary" }, [
                        _vm._v(_vm._s(_vm.servico.taxa))
                      ])
                    ])
                  ]),
                  _c("v-col", [
                    _c("div", [
                      _c("p", { staticStyle: { "margin-bottom": "0px" } }, [
                        _vm._v(" Receita Total: ")
                      ]),
                      _c("small", { staticClass: "text-success" }, [
                        _c("strong", [
                          _vm._v(" " + _vm._s(_vm.dados.receita_total) + " ")
                        ])
                      ])
                    ])
                  ]),
                  _c("v-col", [
                    _c("div", [
                      _c("p", { staticStyle: { "margin-bottom": "0px" } }, [
                        _vm._v(" Proximo mês: ")
                      ]),
                      _c("small", { staticClass: "text-success" }, [
                        _c("strong", [
                          _vm._v(" " + _vm._s(_vm.dados.receita_prox_mes) + " ")
                        ])
                      ])
                    ])
                  ])
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "12", md: "4" } }, [
                    _c("div", [
                      _c("p", { staticStyle: { "margin-bottom": "0px" } }, [
                        _vm._v(" Qtd clientes: ")
                      ]),
                      _c("small", { staticClass: "text-secondary" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.dados.contratados
                                ? _vm.dados.contratados.length
                                : "-"
                            ) +
                            " "
                        )
                      ])
                    ])
                  ]),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("v-text-field", {
                        ref: "linkAdesao",
                        attrs: {
                          readonly: "",
                          label: "Enviar link do serviço (sem comissão)"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "append",
                            fn: function() {
                              return [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  attrs: { icon: "" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.copyClipboard(
                                                        "linkAdesao"
                                                      )
                                                    }
                                                  }
                                                },
                                                on
                                              ),
                                              [
                                                _c("v-icon", [
                                                  _vm._v("mdi-content-copy")
                                                ])
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  },
                                  [_c("span", [_vm._v("Copiar link")])]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ]),
                        model: {
                          value: _vm.link_adesao,
                          callback: function($$v) {
                            _vm.link_adesao = $$v
                          },
                          expression: "link_adesao"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "v-tabs",
                    {
                      model: {
                        value: _vm.tab,
                        callback: function($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab"
                      }
                    },
                    [
                      _c("v-tab", { key: "clientes" }, [_vm._v(" Clientes ")]),
                      !_vm.servico.free
                        ? _c("v-tab", { key: "historico" }, [
                            _vm._v(" Histórico de pagamentos ")
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "v-tabs-items",
                    {
                      model: {
                        value: _vm.tab,
                        callback: function($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab"
                      }
                    },
                    [
                      _c(
                        "v-tab-item",
                        { key: "clientes" },
                        [
                          _vm.dados.contratados
                            ? _c("v-data-table", {
                                attrs: {
                                  headers: _vm.headers,
                                  items: _vm.dados.contratados,
                                  "show-select": "",
                                  height: "220",
                                  "item-key": "login",
                                  search: _vm.searchClient,
                                  "fixed-header": "",
                                  "custom-sort": _vm.customSort
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "item.nome_cliente",
                                      fn: function(ref) {
                                        var item = ref.item
                                        return [
                                          _c(
                                            "td",
                                            [
                                              _c(
                                                "v-row",
                                                {
                                                  staticStyle: {
                                                    "align-items": "center"
                                                  }
                                                },
                                                [
                                                  !item.id_cadastro_cliente
                                                    ? _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            small: "",
                                                            right: "",
                                                            color: "primary"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            " mdi-account "
                                                          )
                                                        ]
                                                      )
                                                    : _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            small: "",
                                                            right: ""
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            " mdi-account-switch "
                                                          )
                                                        ]
                                                      ),
                                                  _c(
                                                    "p",
                                                    {
                                                      staticStyle: {
                                                        "margin-bottom": "0px",
                                                        "margin-left": "5px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.nome_cliente
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "item.action",
                                      fn: function(ref) {
                                        var item = ref.item
                                        return [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                text: "",
                                                icon: "",
                                                small: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.selectedClients(
                                                    item
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v("mdi-chevron-right")
                                              ])
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "no-data",
                                      fn: function() {
                                        return [
                                          _c("p", { staticClass: "pt-3" }, [
                                            _vm._v("Nenhum cliente encontrado")
                                          ]),
                                          _vm.$canSendLinks
                                            ? _c(
                                                "BaseButton",
                                                {
                                                  attrs: {
                                                    primary: "",
                                                    small: ""
                                                  },
                                                  on: {
                                                    click: _vm.openSendLink
                                                  }
                                                },
                                                [_vm._v(" Enviar link ")]
                                              )
                                            : _vm._e()
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  false,
                                  745308810
                                ),
                                model: {
                                  value: _vm.selectedsClients,
                                  callback: function($$v) {
                                    _vm.selectedsClients = $$v
                                  },
                                  expression: "selectedsClients"
                                }
                              })
                            : _c("p", { staticStyle: { padding: "20px" } }, [
                                _vm._v(
                                  " Este serviço ainda não possui contratações. "
                                )
                              ])
                        ],
                        1
                      ),
                      _c(
                        "v-tab-item",
                        { key: "historico" },
                        [
                          _vm.dados.historico_pagamentos
                            ? _c("v-simple-table", {
                                staticClass: "table-ativos",
                                attrs: { "fixed-header": "", height: "250" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function() {
                                        return [
                                          _c("thead", [
                                            _c(
                                              "th",
                                              {
                                                staticClass:
                                                  "text-left border-right",
                                                staticStyle: {
                                                  "max-width": "300px"
                                                }
                                              },
                                              [_vm._v(" Nome ")]
                                            ),
                                            _c(
                                              "th",
                                              { staticClass: "border-right" },
                                              [_vm._v("E-mail")]
                                            ),
                                            _c(
                                              "th",
                                              {
                                                staticClass: "border-right",
                                                attrs: { colspan: "2" }
                                              },
                                              [_vm._v("Valor")]
                                            ),
                                            _c(
                                              "th",
                                              { staticClass: "border-right" },
                                              [_vm._v(" Data de pagamento ")]
                                            )
                                          ]),
                                          _c(
                                            "tbody",
                                            _vm._l(
                                              _vm.dados.historico_pagamentos,
                                              function(v, i) {
                                                return _c(
                                                  "tr",
                                                  { key: "key-" + i },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-left border-right",
                                                        staticStyle: {
                                                          "max-width": "300px",
                                                          cursor: "pointer"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.openClient(
                                                              v
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("div", [
                                                          _c("strong", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  v.nome_cliente
                                                                ) +
                                                                " "
                                                            )
                                                          ])
                                                        ])
                                                      ]
                                                    ),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "border-right"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(v.email) +
                                                            " "
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "border-right",
                                                        attrs: { colspan: "2" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              v.valor_profissional
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "border-right"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              v.data_registro_contratacao
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  false,
                                  3210138603
                                )
                              })
                            : _c("p", { staticStyle: { padding: "20px" } }, [
                                _vm._v(" Este serviço não possui pagamentos ")
                              ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
      _c("ModalIndicacao", { attrs: { bus: _vm.bus } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }